<div class="puppeteer-performance-main">
  <app-performance [params]="params"></app-performance>
</div>
